import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { Icon as CommonIcon } from '../ReactComponent/Icon';
import { StyledMDBDropdownMenu } from '../_styledComponents/MDBDropdownToggle';
import Actions from '../../assets/icons/Actions.svg';
import Download from '../../assets/icons/Download.svg';
import ShipmentBlack from '../../assets/icons/ShipmentBlack.svg';
import {
  StyledMDBDropdownActions, StyledMDBDropdownToggle, DropdownItem, DropdownItemIcon,
} from './css';

const Dropdown = ({
  invoiceNumber, invoiceType, transactionSource, getSingleInvoice, shipmentNumber, viewShipment,
}) => (
  <StyledMDBDropdownActions className="dropdown">
    <StyledMDBDropdownToggle className="border-0">
      {/* <img src={Actions} alt='Actions' /> */}
      <CommonIcon iconSrc={Actions} />
      {/* <span>{t('Actions')}</span> */}
    </StyledMDBDropdownToggle>
    <StyledMDBDropdownMenu className="text-white bg-dark" basic>
      <>
        <DropdownItem onClick={() => getSingleInvoice(invoiceNumber, invoiceType, transactionSource)}>
          <DropdownItemIcon iconSrc={Download} />
          {t('DownloadReport')}
        </DropdownItem>
        {shipmentNumber && shipmentNumber !== 'NA' && (
        <DropdownItem onClick={() => viewShipment(shipmentNumber)}>
          <DropdownItemIcon iconSrc={ShipmentBlack} />
          {t('ViewShipmentDetails')}
        </DropdownItem>
        )}
      </>
    </StyledMDBDropdownMenu>
  </StyledMDBDropdownActions>
);

Dropdown.propTypes = {
  invoiceNumber: PropTypes.string,
  invoiceType: PropTypes.string,
  transactionSource: PropTypes.string,
  getSingleInvoice: PropTypes.func,
  shipmentNumber: PropTypes.string,
  viewShipment: PropTypes.func,
};

export default Dropdown;
